var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reporting-section" }, [
    _c(
      "div",
      { staticClass: "section-header" },
      [
        _c("i", { staticClass: "material-icons section-icon" }, [
          _vm._v("compare_arrows"),
        ]),
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.section.comparison.title"))),
        ]),
        _c("span", { staticClass: "page-count" }, [
          _vm._v(_vm._s(_vm.pagesData.length) + " pages"),
        ]),
        _c(
          "Tooltip",
          {
            attrs: {
              text: _vm.pdfTooltip,
              active: !!(_vm.prevLoading || _vm.concurrentsLoading),
              position: "bottom",
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "btn-pdf",
                attrs: {
                  disabled:
                    _vm.pdfLoading || _vm.prevLoading || _vm.concurrentsLoading,
                },
                on: { click: _vm.downloadComparisonPdf },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(
                    _vm._s(
                      _vm.pdfLoading ? "hourglass_empty" : "picture_as_pdf"
                    )
                  ),
                ]),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.pdfLoading ? "…" : "PDF") +
                    "\n      "
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "comparison-table" },
      [
        _c(
          "div",
          { staticClass: "cmp-row cmp-head" },
          [
            _c("div", { staticClass: "cmp-metric-label" }),
            _vm._l(_vm.pagesData, function (item) {
              return _c(
                "div",
                { key: item.page.id, staticClass: "cmp-page-col" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "page-badge page-badge--clickable",
                      attrs: { title: _vm.$t("dash.reporting.see_detail") },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("drill-down", item.page.id)
                        },
                      },
                    },
                    [
                      item.page.picture_url
                        ? _c("img", {
                            staticClass: "page-avatar",
                            attrs: { src: item.page.picture_url, alt: "" },
                          })
                        : _vm._e(),
                      _c("span", { staticClass: "page-name" }, [
                        _vm._v(_vm._s(item.page.name)),
                      ]),
                      _c("span", { staticClass: "network-badge" }, [
                        _vm._v(_vm._s(item.page.network)),
                      ]),
                      _vm._m(0, true),
                    ]
                  ),
                ]
              )
            }),
            _vm._m(1),
          ],
          2
        ),
        _vm._l(_vm.metrics, function (metric) {
          return _c(
            "div",
            { key: metric.key, staticClass: "cmp-row" },
            [
              _c("div", { staticClass: "cmp-metric-label" }, [
                _vm._v(_vm._s(metric.label)),
              ]),
              _vm._l(_vm.pagesData, function (item) {
                return _c(
                  "div",
                  {
                    key: item.page.id,
                    staticClass: "cmp-page-col",
                    class: {
                      "is-best": _vm.getBest(metric.key) === item.page.id,
                    },
                  },
                  [
                    _c("span", { staticClass: "cmp-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatValue(
                            _vm.getValue(item, metric.key),
                            metric.format
                          )
                        )
                      ),
                    ]),
                    _vm.prevLoading
                      ? _c(
                          "span",
                          { staticClass: "cmp-evol cmp-evol--loading" },
                          [_vm._v("…")]
                        )
                      : _vm.getEvolution(item, metric.key) !== null
                      ? _c(
                          "span",
                          {
                            staticClass: "cmp-evol",
                            class: _vm.evolClass(item, metric.key),
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getEvolution(item, metric.key) >= 0
                                    ? "arrow_upward"
                                    : "arrow_downward"
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formatEvol(
                                    _vm.getEvolution(item, metric.key)
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _c("div", { staticClass: "cmp-page-col cmp-total-col" }, [
                _c("span", { staticClass: "cmp-value cmp-total-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatValue(_vm.getTotal(metric.key), metric.format)
                    )
                  ),
                ]),
                _vm.prevLoading
                  ? _c("span", { staticClass: "cmp-evol cmp-evol--loading" }, [
                      _vm._v("…"),
                    ])
                  : _vm.getTotalEvolution(metric.key) !== null
                  ? _c(
                      "span",
                      {
                        staticClass: "cmp-evol",
                        class: _vm.totalEvolClass(metric.key),
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getTotalEvolution(metric.key) >= 0
                                ? "arrow_upward"
                                : "arrow_downward"
                            )
                          ),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatEvol(_vm.getTotalEvolution(metric.key))
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            2
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "drill-hint" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("open_in_new")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cmp-page-col cmp-total-col" }, [
      _c("div", { staticClass: "page-badge" }, [
        _c("span", { staticClass: "page-name" }, [_vm._v("Total")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }